module.exports = __webpack_public_path__ + "static/media/sunset_16.0b05122c.webp";